/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useGetEventsExternal = makeQueryHook(operations.getEventsExternal)

export const useCreateEvent = makeMutationHook(operations.createEvent)

export const useCreateEventsBulk = makeMutationHook(operations.createEventsBulk)

export const useAmortizationGet = makeMutationHook(operations.amortizationGet)

export const useConsentGet = makeQueryHook(operations.consentGet)

export const useConsentUpdate = makeMutationHook(operations.consentUpdate)

export const useDoNotInteractTypeGetAll = makeQueryHook(
  operations.doNotInteractTypeGetAll,
)

export const useDoNotInteractTypeCreate = makeMutationHook(
  operations.doNotInteractTypeCreate,
)

export const useDoNotInteractTypeGetById = makeQueryHook(
  operations.doNotInteractTypeGetById,
)

export const useDoNotInteractTypeUpdate = makeMutationHook(
  operations.doNotInteractTypeUpdate,
)

export const useNotificationTypeGetAll = makeQueryHook(
  operations.notificationTypeGetAll,
)

export const useNotificationTypeCreate = makeMutationHook(
  operations.notificationTypeCreate,
)

export const useNotificationTypeGetById = makeQueryHook(
  operations.notificationTypeGetById,
)

export const useNotificationTypeUpdate = makeMutationHook(
  operations.notificationTypeUpdate,
)

export const useSnoozeCase = makeMutationHook(operations.snoozeCase)

export const useCaseDoNotInteractGetAll = makeQueryHook(
  operations.caseDoNotInteractGetAll,
)

export const useDoNotInteractCreate = makeMutationHook(
  operations.doNotInteractCreate,
)

export const useDoNotInteractGetById = makeQueryHook(
  operations.doNotInteractGetById,
)

export const useDoNotInteractUpdate = makeMutationHook(
  operations.doNotInteractUpdate,
)

export const useDoNotInteractDelete = makeMutationHook(
  operations.doNotInteractDelete,
)

export const useListCaseNotes = makeQueryHook(operations.listCaseNotes)

export const useCreateCaseNote = makeMutationHook(operations.createCaseNote)

export const useGetCaseNote = makeQueryHook(operations.getCaseNote)

export const useUpdateCaseNote = makeMutationHook(operations.updateCaseNote)

export const useListInteractionNotes = makeQueryHook(
  operations.listInteractionNotes,
)

export const useCreateInteractionNote = makeMutationHook(
  operations.createInteractionNote,
)

export const useGetInteractionNote = makeQueryHook(
  operations.getInteractionNote,
)

export const useUpdateInteractionNote = makeMutationHook(
  operations.updateInteractionNote,
)

export const useListBorrowerNotes = makeQueryHook(operations.listBorrowerNotes)

export const useCreateBorrowerNote = makeMutationHook(
  operations.createBorrowerNote,
)

export const useGetBorrowerNote = makeQueryHook(operations.getBorrowerNote)

export const useUpdateBorrowerNote = makeMutationHook(
  operations.updateBorrowerNote,
)

export const usePeopleDoNotInteractGetAll = makeQueryHook(
  operations.peopleDoNotInteractGetAll,
)

export const useListBorrowerInteractionNotes = makeQueryHook(
  operations.listBorrowerInteractionNotes,
)

export const useLoansGetByCompany = makeQueryHook(operations.loansGetByCompany)

export const useLoansGet = makeQueryHook(operations.loansGet)

export const useLoansAdd = makeMutationHook(operations.loansAdd)

export const useLoanGet = makeQueryHook(operations.loanGet)

export const useLoanUpdate = makeMutationHook(operations.loanUpdate)

export const useGetLockStatus = makeQueryHook(operations.getLockStatus)

export const useGetLoanAdvances = makeQueryHook(operations.getLoanAdvances)

export const useCreateLoanAdvance = makeMutationHook(
  operations.createLoanAdvance,
)

export const useGetLoanAdvance = makeQueryHook(operations.getLoanAdvance)

export const useUpdateLoanAdvance = makeMutationHook(
  operations.updateLoanAdvance,
)

export const useGetLoanPeriods = makeQueryHook(operations.getLoanPeriods)

export const useGetLoanPeriodById = makeQueryHook(operations.getLoanPeriodById)

export const useLoanScheduleOptionsGet = makeQueryHook(
  operations.loanScheduleOptionsGet,
)

export const useLoanActivate = makeMutationHook(operations.loanActivate)

export const useLoanReimburse = makeMutationHook(operations.loanReimburse)

export const useLoanRefundsGet = makeQueryHook(operations.loanRefundsGet)

export const useLoanRefundsPost = makeMutationHook(operations.loanRefundsPost)

export const useLoanRefundsCancel = makeMutationHook(
  operations.loanRefundsCancel,
)

export const useLoanRefundsV2Post = makeMutationHook(
  operations.loanRefundsV2Post,
)

export const useLoanCancel = makeMutationHook(operations.loanCancel)

export const useLoanClose = makeMutationHook(operations.loanClose)

export const useLoanReopen = makeMutationHook(operations.loanReopen)

export const useDrawDynamicFeesAtOriginationUpdate = makeMutationHook(
  operations.drawDynamicFeesAtOriginationUpdate,
)

export const useDrawClose = makeMutationHook(operations.drawClose)

export const useDrawReopen = makeMutationHook(operations.drawReopen)

export const useDrawCancel = makeMutationHook(operations.drawCancel)

export const useLoanGetCreditLimit = makeQueryHook(
  operations.loanGetCreditLimit,
)

export const useLoanUpdateCreditLimit = makeMutationHook(
  operations.loanUpdateCreditLimit,
)

export const useDrawMinPaymentCalculationPost = makeMutationHook(
  operations.drawMinPaymentCalculationPost,
)

export const useDrawGetCreditLimit = makeQueryHook(
  operations.drawGetCreditLimit,
)

export const useDrawUpdateCreditLimit = makeMutationHook(
  operations.drawUpdateCreditLimit,
)

export const useDynamicFeeUpdate = makeMutationHook(operations.dynamicFeeUpdate)

export const useFeesGet = makeQueryHook(operations.feesGet)

export const useFeesPost = makeMutationHook(operations.feesPost)

export const useFeesCancelOne = makeMutationHook(operations.feesCancelOne)

export const useFeesCancel = makeMutationHook(operations.feesCancel)

export const useUpdateOriginationFee = makeMutationHook(
  operations.updateOriginationFee,
)

export const useUpdateDrawFee = makeMutationHook(operations.updateDrawFee)

export const useLoanFreeze = makeMutationHook(operations.loanFreeze)

export const useLoanUnfreeze = makeMutationHook(operations.loanUnfreeze)

export const useLoanChargeOff = makeMutationHook(operations.loanChargeOff)

export const useLoanChargeOffReverse = makeMutationHook(
  operations.loanChargeOffReverse,
)

export const useLoanAccelerate = makeMutationHook(operations.loanAccelerate)

export const useLoanAccelerateReverse = makeMutationHook(
  operations.loanAccelerateReverse,
)

export const useLoanAgentDashboardToolsGet = makeQueryHook(
  operations.loanAgentDashboardToolsGet,
)

export const useLoanCustomPaymentPlanGet = makeQueryHook(
  operations.loanCustomPaymentPlanGet,
)

export const useLoanCustomPaymentPlanCreate = makeMutationHook(
  operations.loanCustomPaymentPlanCreate,
)

export const useLoanCustomPaymentPlanGetById = makeQueryHook(
  operations.loanCustomPaymentPlanGetById,
)

export const useLoanCustomPaymentPlanCancel = makeMutationHook(
  operations.loanCustomPaymentPlanCancel,
)

export const useLoanChangeTerms = makeMutationHook(operations.loanChangeTerms)

export const useLoanDueDateDefer = makeMutationHook(operations.loanDueDateDefer)

export const useLoanScheduleDefer = makeMutationHook(
  operations.loanScheduleDefer,
)

export const useLoanRefresh = makeMutationHook(operations.loanRefresh)

export const useLoanRatesGet = makeQueryHook(operations.loanRatesGet)

export const useLoanRatesAdd = makeMutationHook(operations.loanRatesAdd)

export const useLoanEffectiveRatesGet = makeQueryHook(
  operations.loanEffectiveRatesGet,
)

export const useLoanRatesUpdate = makeMutationHook(operations.loanRatesUpdate)

export const useLoanRatesDelete = makeMutationHook(operations.loanRatesDelete)

export const useDrawRatesGet = makeQueryHook(operations.drawRatesGet)

export const useDrawRatesAdd = makeMutationHook(operations.drawRatesAdd)

export const useDrawEffectiveRatesGet = makeQueryHook(
  operations.drawEffectiveRatesGet,
)

export const useDrawRatesUpdate = makeMutationHook(operations.drawRatesUpdate)

export const useDrawRatesDelete = makeMutationHook(operations.drawRatesDelete)

export const useObligationsGetAll = makeQueryHook(operations.obligationsGetAll)

export const useObligationCreate = makeMutationHook(operations.obligationCreate)

export const useDrawObligationsGetAll = makeQueryHook(
  operations.drawObligationsGetAll,
)

export const useObligationGetById = makeQueryHook(operations.obligationGetById)

export const useObligationUpdate = makeMutationHook(operations.obligationUpdate)

export const useDrawObligationGetById = makeQueryHook(
  operations.drawObligationGetById,
)

export const useLoanDrawsGet = makeQueryHook(operations.loanDrawsGet)

export const useLoanDrawsPost = makeMutationHook(operations.loanDrawsPost)

export const useLoanDrawGet = makeQueryHook(operations.loanDrawGet)

export const useDrawUpdate = makeMutationHook(operations.drawUpdate)

export const useDrawActivate = makeMutationHook(operations.drawActivate)

export const usePreviewDrawAmortize = makeMutationHook(
  operations.previewDrawAmortize,
)

export const useLoanDrawAmortize = makeMutationHook(operations.loanDrawAmortize)

export const useDrawPurchasesGet = makeQueryHook(operations.drawPurchasesGet)

export const useDrawPurchasesCreate = makeMutationHook(
  operations.drawPurchasesCreate,
)

export const useDrawPurchasesTimelineGet = makeQueryHook(
  operations.drawPurchasesTimelineGet,
)

export const useDrawPurchaseGetOne = makeQueryHook(
  operations.drawPurchaseGetOne,
)

export const useDrawPurchaseUpdate = makeMutationHook(
  operations.drawPurchaseUpdate,
)

export const useLoanPurchasesGet = makeQueryHook(operations.loanPurchasesGet)

export const useAliasLoanPurchasesGet = makeQueryHook(
  operations.aliasLoanPurchasesGet,
)

export const useLoanPurchasesTimelineGet = makeQueryHook(
  operations.loanPurchasesTimelineGet,
)

export const useGenerateStatement = makeMutationHook(
  operations.generateStatement,
)

export const useLoanAutopayGet = makeQueryHook(operations.loanAutopayGet)

export const useLoanAutopayPut = makeMutationHook(operations.loanAutopayPut)

export const useLoanAutopayPost = makeMutationHook(operations.loanAutopayPost)

export const useLoanAutopayDelete = makeMutationHook(
  operations.loanAutopayDelete,
)

export const useLoanInterestGet = makeQueryHook(operations.loanInterestGet)

export const useLoanBalancesGet = makeQueryHook(operations.loanBalancesGet)

export const useLoanFutureBalancesGet = makeQueryHook(
  operations.loanFutureBalancesGet,
)

export const useDrawBalancesGet = makeQueryHook(operations.drawBalancesGet)

export const useDrawFutureBalancesGet = makeQueryHook(
  operations.drawFutureBalancesGet,
)

export const useLoanInvestorsGetAll = makeQueryHook(
  operations.loanInvestorsGetAll,
)

export const useLoanInvestorsUpdate = makeMutationHook(
  operations.loanInvestorsUpdate,
)

export const usePersonPaymentInstrumentGetAll = makeQueryHook(
  operations.personPaymentInstrumentGetAll,
)

export const usePersonPaymentInstrumentCreate = makeMutationHook(
  operations.personPaymentInstrumentCreate,
)

export const usePersonPaymentInstrumentGet = makeQueryHook(
  operations.personPaymentInstrumentGet,
)

export const usePersonPaymentInstrumentUpdate = makeMutationHook(
  operations.personPaymentInstrumentUpdate,
)

export const usePersonPaymentInstrumentDelete = makeMutationHook(
  operations.personPaymentInstrumentDelete,
)

export const usePersonPaymentInstrumentVerify = makeMutationHook(
  operations.personPaymentInstrumentVerify,
)

export const useAccountLinkPut = makeMutationHook(operations.accountLinkPut)

export const useAccountLinkPost = makeMutationHook(operations.accountLinkPost)

export const useAccountLinkDelete = makeMutationHook(
  operations.accountLinkDelete,
)

export const useBalancesGet = makeQueryHook(operations.balancesGet)

export const useBalancesPost = makeMutationHook(operations.balancesPost)

export const useLegalRepresentativeGetAll = makeQueryHook(
  operations.legalRepresentativeGetAll,
)

export const useLegalRepresentativeAdd = makeMutationHook(
  operations.legalRepresentativeAdd,
)

export const useLegalRepresentativeGetById = makeQueryHook(
  operations.legalRepresentativeGetById,
)

export const useLegalRepresentativeUpdate = makeMutationHook(
  operations.legalRepresentativeUpdate,
)

export const useLoanCreditreportingGet = makeQueryHook(
  operations.loanCreditreportingGet,
)

export const useLoanCreditreportingUpdate = makeMutationHook(
  operations.loanCreditreportingUpdate,
)

export const useLoanCreditreportingDelete = makeMutationHook(
  operations.loanCreditreportingDelete,
)

export const useLoanCreditreportingsGet = makeQueryHook(
  operations.loanCreditreportingsGet,
)

export const useLoanCreditreportingsAdd = makeMutationHook(
  operations.loanCreditreportingsAdd,
)

export const useGetPaymentProcessors = makeQueryHook(
  operations.getPaymentProcessors,
)

export const useCreatePaymentProcessor = makeMutationHook(
  operations.createPaymentProcessor,
)

export const useGetOnePaymentProcessor = makeQueryHook(
  operations.getOnePaymentProcessor,
)

export const useUpdatePaymentProcessor = makeMutationHook(
  operations.updatePaymentProcessor,
)

export const useDeletePaymentProcessor = makeMutationHook(
  operations.deletePaymentProcessor,
)

export const useGetAchFileContent = makeQueryHook(operations.getAchFileContent)

export const useOperationStatusGet = makeQueryHook(
  operations.operationStatusGet,
)
